import React, { useState } from 'react';
import styles from './Login.module.css'; // Assuming we'll create a CSS module for styling

function Login({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = () => {
    // In a real application, you would send the password to a backend for verification.
    // Here, we compare it directly with an environment variable for simplicity as requested.
    // NOTE: Storing sensitive passwords in client-side environment variables is NOT secure
    // and should only be done for demonstration or specific local-only use cases.
    const correctPassword = process.env.REACT_APP_PASSWORD; // Assuming the env var is prefixed with REACT_APP_

    if (password === correctPassword) {
      localStorage.setItem('isLoggedIn', 'true');
      onLogin(); // Call the function passed from App.js to indicate successful login
    } else {
      setError('密码错误');
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div className={styles.loginContainer}>
      <h2>请登录</h2>
      <div className={styles.inputGroup}>
        <label htmlFor="password">密码:</label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
          className={styles.passwordInput}
        />
      </div>
      {error && <p className={styles.error}>{error}</p>}
      <button onClick={handleLogin} className={styles.loginButton}>登录</button>
    </div>
  );
}

export default Login;
